import { Component } from '@angular/core';
import { UserData } from '../../../../providers/user-data';
import { Events, LoadingController, NavController, NavParams } from 'ionic-angular';
import { PageBaseFull } from '../../../../core/page-base.full';
import { AppSettings } from '../../../../config/app-settings';
import { RecipeListCommon } from './recipe-list.common';
import { AngularFireDatabaseWrapper } from '../../../../providers/angularfire-wrapper';
import { RecipeData } from '../../providers/recipe-data';
import { RecipeBoxDataGateway } from '../../providers/recipe-box-data-gateway';
import { RecipeBoxesPageFull } from '../recipe-boxes/recipe-boxes.full';
import { RecipeDetailPageFull } from '../recipe-detail/recipe-detail.full';
import 'rxjs/add/operator/combineAll';
import 'rxjs/add/operator/mergeAll';

@Component({
	selector: 'recipe-list-full',
	templateUrl: 'recipe-list.full.html'
})
export class RecipeListPageFull extends PageBaseFull {
	public recipesList: any;
	public recipeCategories: any;
	public loader: any;
	public userRecipes = [];
	public recipeBoxData: any;
	public userId = '';
	public categoryUrlSlug = 'all';
	public category: any;
	public pageSize: Number = 12;
	public pageIndex: Number = 0;
	public hasMore = false;
	public search = '';
	public keyword = '';
	public totalRecords = 0;
	constructor(
		public nav: NavController,
		public userData: UserData,
		public settings: AppSettings,
		public common: RecipeListCommon,
		public events: Events,
		// public storage: Storage,
		public afw: AngularFireDatabaseWrapper,
		public loadingCtrl: LoadingController,
		public recipeData: RecipeData,
		public recipeBoxGateway: RecipeBoxDataGateway,
		private navParams: NavParams
	) {
		super(settings, events, nav, userData);
		this.categoryUrlSlug = navParams.get('categoryUrlSlug');
		this.keyword = navParams.get('keyword');
	}
	ngAfterViewInit() {
		//this.common.commonMethod();

	}
	ionViewDidEnter() {
		this.loader = this.loadingCtrl.create();
		this.userId = this.currentUser ? this.currentUser.uid : null;
		this.recipeBoxData = this.recipeBoxGateway.getService(this.userId);
		this.loadData();

	}
	public loadData() {
		this.loader.present();
		// if(self.categoryUrlSlug && self.categoryUrlSlug != '' && self.categoryUrlSlug != 'all'){
		this.getAllCategoriesData().subscribe(categoriesRes => {
			this.category = _.find(categoriesRes, (value: any, key) => {
				return value.urlSlug == this.categoryUrlSlug;
			});
			if (!this.category) {
				this.category = { $key: 'All', name: 'All' };
				// this.keyword = '';
			}
			this.getRecipesData().subscribe(recipes => {
				// this.category.totalRecipes = recipes.totalRecords;
				this.loader.dismiss();
			});
		});


	}

	// public getRecipesByCategory(category) {
	// 	this.categoryUrlSlug = category.urlSlug;
	// 	this.getLocalRecipes().then(recipes => {
	// 		if (recipes) {
	// 			this.recipesList = _.filter(recipes, recipe => {
	// 				return _.find(recipe['categories'], (value, key) => {
	// 					return key == category.$key;
	// 				});
	// 			});
	// 		}
	// 	});
	// }
	// public getLocalRecipes() {
	// 	return this.recipeData.getLocalRecipes();
	// }
	// public getAllRecipes() {
	// 	Observable.from([this.getAllRecipesData(), this.getAllCategoriesData()]).combineAll().subscribe(() => {

	// 	});
	// }
	public changPage(pageIndex) {
		this.loader = this.loadingCtrl.create();

		this.loader.present();
		this.pageIndex = pageIndex;
		this.getRecipesData().subscribe(result => {
			this.loader.dismiss();

		});
	}
	public getRecipesData() {
		// this.categoryUrlSlug = 'all';
		// this.category = { $key: 'All', name: 'All' };
		return this.recipeData.getRecipesFullData(this.category.$key, this.keyword, this.userId, this.pageSize, this.pageIndex).map(recipes => {
			this.recipesList = recipes.items;
			if (recipes.length < this.pageSize || this.pageIndex == recipes.pages - 1) {
				this.hasMore = false;
			}
			else {
				this.hasMore = true;
			}
			// this.saveRecipesToLocalStorage();
			return recipes;
		});
	}
	public getAllCategoriesData() {
		return this.recipeData.getAllCategories().map(recipeCategories => {
			if (recipeCategories) {
				_.forEach(recipeCategories, category => {
					category.totalRecipes = category.items ? Object.keys(category.items).length : 0;
				});
				this.recipeCategories = recipeCategories;
			}
			return recipeCategories;
		});
	}

	//select favorite
	addOrRemoveUserRecipe(recipe) {
		if (!recipe.isFavorite) {
			this.recipeBoxData.add(this.userId, recipe).then(userRecipe => {
				recipe.isFavorite = true;
			});

		}
		else {
			this.recipeBoxData.remove(this.userId, recipe).then(result => {
				if (result)
					recipe.isFavorite = false;
			});
		}

	}
	// getUserRecipeKeys(recipeId) {
	// 	var favoriteRecipes = _.filter(this.userRecipes, function (userRecipe: any) {
	// 		return userRecipe.recipeId === recipeId;
	// 	});
	// 	favoriteRecipes = _.map(favoriteRecipes, '$id');
	// 	if (favoriteRecipes)
	// 		return favoriteRecipes;
	// 	return [];
	// }
	public selectRecipeBox() {
		this.nav.push(RecipeBoxesPageFull, { categoryUrlSlug: this.categoryUrlSlug });
	}
	//Recipe detail
	viewRecipeDetail(recipe) {
		console.log(recipe);
		this.nav.push(RecipeDetailPageFull, { categoryUrlSlug: this.categoryUrlSlug, id: recipe.$id ? recipe.$id : recipe.$key });
	}

	viewRecipeCategory(categoryUrlSlug) {
		if (!categoryUrlSlug)
			categoryUrlSlug = 'all';
		this.nav.push(RecipeListPageFull, { categoryUrlSlug: categoryUrlSlug, keyword: this.keyword });
	}
	searchRecipes(keyword) {
		this.loader = this.loadingCtrl.create();
		this.loader.present();
		this.keyword = keyword;
		this.pageIndex = 0;
		this.getRecipesData().subscribe(result => {
			this.loader.dismiss();

		});
	}
	cleanUpKeyword() {
		this.keyword = '';
	}
}


// WEBPACK FOOTER //
// ./src/modules/recipes/pages/recipe-list/recipe-list.full.ts